import { createFileRoute } from "@tanstack/react-router"

// Import the existing billing page component
import Billing from "@/features/earns/components/billing-page"

export const Route = createFileRoute("/_app/billing")({
  component: BillingPage
})

function BillingPage() {
  return <Billing />
}
